import {OrderItem, StartEndTimeWindow, WeightUnit} from '@shipwell/corrogo-sdk';
import moment from 'moment';
import {numberWithCommas} from 'App/utils/globals';
import {convertKilogramsToPounds} from 'App/utils/internationalConstants';

export const getTotalWeight = (items?: OrderItem[]) => {
  const totalWeight = items?.reduce((memo, item) => {
    const value =
      item.amount.unit === WeightUnit.Lb
        ? item.amount.value
        : Number(item.shipping_requirements?.gross_weight?.value) * Number(item.shipping_requirements?.quantity) || 0;
    const unit = item.shipping_requirements?.gross_weight?.unit || WeightUnit.Lb;
    return memo + Number(unit === WeightUnit.Lb ? value : convertKilogramsToPounds(value));
  }, 0);
  return totalWeight ? `${numberWithCommas(totalWeight)} LB` : '--';
};

export const getRange = (planWindow: StartEndTimeWindow | undefined, timezone: string | undefined) => {
  if (!planWindow) {
    return '--';
  }
  return [...new Set([planWindow.start, planWindow.end])]
    .filter(Boolean)
    .map((datetime) =>
      datetime ? moment.tz(datetime, timezone ?? moment.tz.guess()).format('ddd, MMM D [at] HH:mm z') : ''
    )
    .map((datetime, index) => (
      <>
        {index > 0 ? (
          <>
            {' '}
            to <br />
          </>
        ) : null}
        <span>{datetime}</span>
      </>
    ));
};
